/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { globalSettingsGet } from '../fn/global-settings/global-settings-get';
import { GlobalSettingsGet$Params } from '../fn/global-settings/global-settings-get';
import { globalSettingsGetGlobalSettings } from '../fn/global-settings/global-settings-get-global-settings';
import { GlobalSettingsGetGlobalSettings$Params } from '../fn/global-settings/global-settings-get-global-settings';
import { globalSettingsPatientdemographics } from '../fn/global-settings/global-settings-patientdemographics';
import { GlobalSettingsPatientdemographics$Params } from '../fn/global-settings/global-settings-patientdemographics';
import { globalSettingsPost } from '../fn/global-settings/global-settings-post';
import { GlobalSettingsPost$Params } from '../fn/global-settings/global-settings-post';
import { PatientDemographics } from '../models/patient-demographics';
import { UiPreferences } from '../models/ui-preferences';

@Injectable({ providedIn: 'root' })
export class GlobalSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `globalSettingsPost()` */
  static readonly GlobalSettingsPostPath = '/api/GlobalSettings/emergencytoken/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalSettingsPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsPost$Response(params?: GlobalSettingsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalSettingsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalSettingsPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsPost(params?: GlobalSettingsPost$Params, context?: HttpContext): Observable<Blob> {
    return this.globalSettingsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `globalSettingsPatientdemographics()` */
  static readonly GlobalSettingsPatientdemographicsPath = '/api/GlobalSettings/patientdemographics/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalSettingsPatientdemographics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalSettingsPatientdemographics$Response(params: GlobalSettingsPatientdemographics$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return globalSettingsPatientdemographics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalSettingsPatientdemographics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  globalSettingsPatientdemographics(params: GlobalSettingsPatientdemographics$Params, context?: HttpContext): Observable<Blob> {
    return this.globalSettingsPatientdemographics$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `globalSettingsGet()` */
  static readonly GlobalSettingsGetPath = '/api/GlobalSettings/patientdemographics/fetch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalSettingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsGet$Response(params?: GlobalSettingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDemographics>> {
    return globalSettingsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalSettingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsGet(params?: GlobalSettingsGet$Params, context?: HttpContext): Observable<PatientDemographics> {
    return this.globalSettingsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientDemographics>): PatientDemographics => r.body)
    );
  }

  /** Path part for operation `globalSettingsGetGlobalSettings()` */
  static readonly GlobalSettingsGetGlobalSettingsPath = '/api/GlobalSettings/getGlobalSettings/fetch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalSettingsGetGlobalSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsGetGlobalSettings$Response(params?: GlobalSettingsGetGlobalSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UiPreferences>> {
    return globalSettingsGetGlobalSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalSettingsGetGlobalSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSettingsGetGlobalSettings(params?: GlobalSettingsGetGlobalSettings$Params, context?: HttpContext): Observable<UiPreferences> {
    return this.globalSettingsGetGlobalSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<UiPreferences>): UiPreferences => r.body)
    );
  }

}
